// تبويب سجل التدقيق داخل صفحة /permissions — يعرض من غيّر لمن ومتى.
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { History } from "lucide-react";
import { CardHeader, ToneCard } from "../admin/cardTone";
import { listAudit } from "../../api/permissions";
import { localDateTime } from "../../lib/datetime";

const fmt = (ts) => localDateTime(ts);

export function AuditLogTab() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listAudit(200)
      .then((d) => setItems(d.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <ToneCard tone="amber" testId="perms-audit">
      <CardHeader icon={History} tone="amber" title={t("perms.audit.title")}
                  hint={t("perms.audit.hint")} />
      <ul className="mt-4 grid gap-2" data-testid="perms-audit-list">
        {loading ? <p className="py-6 text-center text-sm">{t("app.loading")}</p> : null}
        {!loading && items.length === 0
          ? <p className="py-8 text-center text-sm text-muted-foreground">{t("app.none")}</p>
          : null}
        {items.map((it, i) => (
          <li key={i} className="rounded-2xl border border-border/50 px-4 py-3 text-xs"
              data-testid={`perms-audit-row-${i}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className="font-bold">{t("perms.audit.user")}: {it.user_name || it.user_id}</span>
              <span className="text-muted-foreground">{fmt(it.at)}</span>
            </div>
            <p className="mt-1 text-muted-foreground">
              {t("perms.audit.by")}: {it.actor_name || it.actor_id} · {t("perms.audit.count", { n: (it.permissions || []).length })}
            </p>
          </li>
        ))}
      </ul>
    </ToneCard>
  );
}
